import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const BlueAura = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e6f2fb',
      100: '#cce5f7',
      200: '#99ccf0',
      300: '#66b3e8',
      400: '#339ae1',
      500: '#0F6CBD', // 💙 your main brand blue
      600: '#0d61aa',
      700: '#0a4d86',
      800: '#083a63',
      900: '#052740',
      950: '#031626',
    },
  },
});

export default BlueAura;
